<template>
  <div>
    <div class="bj">
      <div class="bjContent">
        <div class="bjCont">
          <div class="iconfont icon-close cha" @click="delClick"></div>
          <div class="cont">
            <div class="contHead">公众号发布</div>
            <div class="contBox">
              <div class="name"><span>*</span>姓名</div>
              <div class="inpBox">
                <a-input placeholder="请输入姓名" v-model="name" />
              </div>
            </div>
            <div class="contBox">
              <div class="name"><span>*</span>手机账号</div>
              <div class="inpBox">
                <a-input placeholder="请输入手机账号" v-model="mobile" />
              </div>
            </div>
            <div class="contBox">
              <div class="name"><span>*</span>内容</div>
              <a-textarea
                v-model="content"
                placeholder="请填写您的评价~"
                :auto-size="{ minRows: 3, maxRows: 8 }"
              />
            </div>
            <div class="contBox">
              <div class="name"><span>*</span>上传广告图</div>
              <div class="upImg">
                <div class="imgs">
                  <div
                    class="img"
                    @click="uploadFile"
                    v-if="imgList.length < 9"
                  >
                    <div class="imgBox iconfont icon-camera_fill"></div>
                  </div>
                  <div class="img" v-for="(item, index) in imgList">
                    <img :src="$imgUrl + item.path_name" />
                    <div
                      class="iconfont icon-close close"
                      @click="imgDelClick(index)"
                    ></div>
                  </div>
                </div>
              <div class="tishi">温馨提示：XXXXXXXXXX。</div>
            </div>
            </div>
          </div>
          <div class="gnBox">
            <div class="btn qx" @click="delClick">取消</div>
            <div class="btn" @click="fbClick">提交</div>
          </div>
        </div>
      </div>
    </div>
    <input
      type="file"
      ref="fileInput"
      @change="onFileChange"
      style="display: none"
    />
  </div>
</template>
<script>
import { Select, Form, Input, Button, Upload, Icon } from "ant-design-vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-button": Button,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
  },
  data() {
    return {
      size: "default",
      content: "",
      name: "",
      mobile: "",
      headers: {
        authorization: "authorization-text",
      },
      form: {
        username: "",
        password: "",
      },
      qd: 0,
      on: 0,
      setar: 5,
      imgList: [],
    };
  },
  mounted() {},
  activated() {},
  methods: {
    mouseover(i) {
      this.on = i + 1;
    },
    mouseout(i) {
      if (!this.qd) {
        this.on = 0;
      } else {
        this.on = this.qd;
      }
    },
    cpClick(i) {
      this.qd = i + 1;
      this.on = i + 1;
    },
    delClick() {
      this.$emit("show");
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
    },
    handleChange(value) {
      console.log(`Selected: ${value}`);
    },
    popupScroll() {
      console.log("popupScroll");
    },
    imgDelClick(i) {
      this.imgList.splice(i, 1);
    },
    async uploadFile() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      var formData = new FormData();
      console.log(e.target.files);
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        console.log(res);
        if (res.data.status) {
          this.imgList.push(res.data.data);
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    fbClick(){
      let data ={
        mobile: this.mobile,
        name: this.name,
        content: this.content,
      }
      let resource = [];
      for (let i = 0; i < this.imgList.length; i++) {
        const e = this.imgList[i];
        resource.push(e.id);
      }
      data.resource = resource.join(",");
      console.log(data);
      data = JSON.stringify(data)
      this.$post("/nozzle/web/official_save", {
        data: data,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("发布成功，请耐心等待审核~");
          this.$emit("show", { data: res.data.data });
        } else {
          this.$message.warning(res.data.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bjContent {
  display: flex;
  width: 100%;
  justify-content: center;

  .bjCont {
    background-color: #fff;
    width: 600px;
    margin-top: 90px;
    border-radius: 10px;
    position: relative;

    .cha {
      position: absolute;
      cursor: pointer;
      top: 10px;
      font-weight: 600;
      right: 20px;
      color: #9c9c9c;
    }

    .cont {
      padding: 20px 20px 10px;

      .contHead {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
      .dfBox {
        display: flex;
        align-items: center;
        margin-top: 15px;
        .name {
          width: 80px;
          font-weight: 600;
        }
        .box {
          display: flex;
          align-items: center;
          .iconfont {
            font-size: 20px;
            color: #c9c9c9;
            cursor: pointer;
          }
          .on {
            color: #e23;
          }
        }
      }

      .contBox {
        padding-top: 10px;
        margin-bottom: 5px;

        .name {
          margin-bottom: 5px;

          span {
            color: #f30000;
          }
        }

        .tishi {
          line-height: 150%;
          color: #bfbfbf;
          font-size: 12px;
          margin-top: 5px;
          text-align: justify;
        }

        .upImg {
          margin-top: 10px;

          .text {
            margin-left: 20px;
            font-size: 12px;
          }

          .txt {
            margin-left: 5px;
            font-size: 12px;
            color: #999;
          }

          .imgs {
            display: flex;
            margin-top: 15px;
            flex-wrap: wrap;

            .img {
              width: calc(20% - 12px);
              margin-right: 15px;
              padding-top: calc(20% - 12px);
              position: relative;
              margin-bottom: 15px;
              overflow: unset;
              .imgBox {
                width: 100%;
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                border-radius: 5px;
                box-shadow: 0 0 4px 2px #ebebeb;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #9c9c9c;
                font-size: 20px;
                cursor: pointer;
              }
              img {
                position: absolute;
                top: 0;
                left: 0;
                border-radius: 5px;
              }

              .close {
                position: absolute;
                top: -3px;
                right: -3px;
                background-color: #b3b3b3;
                border-radius: 50%;
                width: 15px;
                height: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 10px;
                color: #fff;
                cursor: pointer;
              }
            }

            .img:nth-child(5n) {
              margin-right: 0;
            }
          }
        }
      }
    }

    .gnBox {
      border-top: 1px solid #d9d9d9;
      padding: 10px 24px;
      overflow: hidden;
      display: flex;
      justify-content: flex-end;

      .btn {
        color: #fff;
        background: rgb(4, 114, 240);
        border: 1px solid rgb(34, 129, 238);
        padding: 5px 15px;
        font-size: 12px;
        border-radius: 5px;
        margin-left: 15px;
        cursor: pointer;
      }

      .qx {
        background: unset;
        border: 1px solid rgb(180, 180, 180);
        color: #666;
      }
    }
  }
}
</style>
